import QualityImg from 'routes/Home/WhyChooseGousto/assets/quality.jpg'
import SimplicityImg from 'routes/Home/WhyChooseGousto/assets/simplicity.jpg'
import VarietyImg from 'routes/Home/WhyChooseGousto/assets/variety.jpg'

export const STEPS_LIST = [
  {
    title: 'Variety',
    img: VarietyImg,
    list: [
      '75+ recipes a week, cooked from 10 mins',
      'Family classics, global cuisines plus Joe Wicks’s health range',
      'Tasty plant based and gluten free options too',
    ],
  },
  {
    title: 'Quality',
    img: QualityImg,
    list: [
      'Fresh ingredients from trusted suppliers',
      'We always buy high quality, 100% British fresh meat, where possible',
      'All recipes tried, tested and loved by our chefs and customers',
    ],
  },
  {
    title: 'Simplicity',
    img: SimplicityImg,
    list: [
      'Easy-to-follow recipe cards',
      'Precise ingredients with zero food waste',
      'Delivered to your door, 7 days a week',
    ],
  },
]
export const SECTION_TITLE = 'So why Gousto?'
